module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAUCAIAAACIxBMbAAAA/ElEQVRIx2PgLwxiyHDHg/ynN/wnBO4nFZwTVMOPGEZtGrWJApt+/Pj88sbRdS3xLaFWZ7Yvp6FND29su7K2akNbfKmHdrK18q1Th2hi06e3Ny5c2LZnXnVrmntXtFVTkG5vmi/1bXrw8OL3+7fvXVhxYk1td5pHXWro9qUzF/c137t/lso2PXp0YsfhY3P2bL1zbM2ORZMrU/yn1OY/e3z39u1DVLbp6bMbt28eWHzqRNW27dlLZpYt6a1bt+nurUN375+hfjxdvrr37O1T8w9tXjkxfemuNQ8fnDp3cRut0t6rV7fPnN107fjBs2c3vn//bLSMGLVpSNgEAEQ/EpHAYWyBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/mx.png
// module id = 892
// module chunks = 0